module.exports = __webpack_public_path__ + "img/france-leukaemia-male.7cc2a478.png";